import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { handleScrollToClass } from "../../../../utils";
import { handleNavigationWithScroll } from "../../../../utils/handleNavigationWithScroll";
import footerLogoImage from '../../../../assets/images/footer_logo.svg';
import phoneImage from '../../../../assets/images/phone.svg';
import mailImage from '../../../../assets/images/mail.svg';
import locationImage from '../../../../assets/images/location.svg';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <footer className="footer-marketing">
      <div className="custom-container d-flex items-center width-100">
        <div className="width-100">
          <div className="footer-marketing__container">
            <div className="footer-marketing__col footer-marketing__brand">
              <div className="footer-marketing__logo-row d-flex items-center">
                <img src={footerLogoImage} alt="LottoReco Logo" />
              </div>
              <p className="footer-marketing__desc">
                Gain full control over your lottery inventory, sales, and
                employee accountability — all from a centralized,
                compliance-ready platform.
              </p>
            </div>
            <nav className="footer-marketing__col" aria-label="Useful Links">
              <div className="footer-marketing__title">Useful Links</div>
              <ul className="footer-marketing__links d-flex flex-column">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleScrollToClass(
                        "features-scroll-element",
                        navigate,
                        location
                      );
                    }}
                  >
                    Features
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleScrollToClass(
                        "workflow-scroll-element",
                        navigate,
                        location
                      );
                    }}
                  >
                    How It Works
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleScrollToClass(
                        "whyChoose-scroll-element",
                        navigate,
                        location
                      );
                    }}
                  >
                    Why Choose
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleScrollToClass(
                        "pricing-scroll-element",
                        navigate,
                        location
                      );
                    }}
                  >
                    Pricing
                  </a>
                </li>
        <li>
          <a
            href="/blog/role-lottoreco-lottery-theft-prevention"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/role-lottoreco-lottery-theft-prevention', navigate);
            }}
          >
            Lottery Theft Prevention Guide
          </a>
        </li>
        <li>
          <a
            href="/blog/true-cost-lottery-shrink-convenience-stores"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/true-cost-lottery-shrink-convenience-stores', navigate);
            }}
          >
            True Cost of Lottery Shrink
          </a>
        </li>
        <li>
          <a
            href="/blog/why-cctv-cant-stop-lottery-theft"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/why-cctv-cant-stop-lottery-theft', navigate);
            }}
          >
            Why CCTV Can't Stop Theft
          </a>
        </li>
        <li>
          <a
            href="/blog/automated-lottery-reconciliation-45-minutes-to-5-minutes"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/automated-lottery-reconciliation-45-minutes-to-5-minutes', navigate);
            }}
          >
            45 Minutes to 5 Minutes
          </a>
        </li>
        <li>
          <a
            href="/blog/california-lottery-compliance-checklist-2025"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/california-lottery-compliance-checklist-2025', navigate);
            }}
          >
            CA Compliance Checklist
          </a>
        </li>
        <li>
          <a
            href="/blog/white-label-lottery-management"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/white-label-lottery-management', navigate);
            }}
          >
            White-Label Lottery Management
          </a>
        </li>
        <li>
          <a
            href="/blog/multi-store-lottery-management"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/multi-store-lottery-management', navigate);
            }}
          >
            Multi-Store Lottery Management
          </a>
        </li>
        <li>
          <a
            href="/blog/erp-integration-lottery-management"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/erp-integration-lottery-management', navigate);
            }}
          >
            ERP Integration for Lottery
          </a>
        </li>
        <li>
          <a
            href="/blog/enterprise-buyers-guide-lottery-software"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/enterprise-buyers-guide-lottery-software', navigate);
            }}
          >
            Enterprise Buyer's Guide
          </a>
        </li>
        <li>
          <a
            href="/blog/scaling-lottery-operations-beyond-50-stores"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/scaling-lottery-operations-beyond-50-stores', navigate);
            }}
          >
            Scaling Beyond 50 Stores
          </a>
        </li>
        <li>
          <a
            href="/blog/api-first-lottery-integration-architecture"
            onClick={(e) => {
              e.preventDefault();
              handleNavigationWithScroll('/blog/api-first-lottery-integration-architecture', navigate);
            }}
          >
            API-First Architecture
          </a>
        </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleScrollToClass(
                        "faq-section__scroll-element",
                        navigate,
                        location
                      );
                    }}
                  >
                    FAQ's
                  </a>
                </li>
                <li>
                  <a
                    href="/support"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigationWithScroll('/support', navigate);
                    }}
                  >
                    Support
                  </a>
                </li>
                <li>
                  <a
                    href="/manual"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigationWithScroll('/manual', navigate);
                    }}
                  >
                    User Manual
                  </a>
                </li>
              </ul>
            </nav>
            <nav className="footer-marketing__col" aria-label="Solutions">
              <div className="footer-marketing__title">Solutions</div>
              <ul className="footer-marketing__links d-flex flex-column">
                <li>
                  <a
                    href="/lottery-theft-prevention"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigationWithScroll('/lottery-theft-prevention', navigate);
                    }}
                  >
                    Theft Prevention
                  </a>
                </li>
                <li>
                  <a
                    href="/lottery-reconciliation-software"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigationWithScroll('/lottery-reconciliation-software', navigate);
                    }}
                  >
                    Reconciliation
                  </a>
                </li>
                <li>
                  <a
                    href="/california-lottery-compliance"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigationWithScroll('/california-lottery-compliance', navigate);
                    }}
                  >
                    CA Compliance
                  </a>
                </li>
                <li>
                  <a
                    href="/convenience-store-lottery-management"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigationWithScroll('/convenience-store-lottery-management', navigate);
                    }}
                  >
                    C-Store Management
                  </a>
                </li>
                <li>
                  <a
                    href="/scratch-ticket-inventory-tracking"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigationWithScroll('/scratch-ticket-inventory-tracking', navigate);
                    }}
                  >
                    Inventory Tracking
                  </a>
                </li>
              </ul>
            </nav>
            <nav className="footer-marketing__col" aria-label="Resources">
              <div className="footer-marketing__title">Resources</div>
              <ul className="footer-marketing__links d-flex flex-column">
                <li>
                  <a href="/terms-of-service" target="_blank">
                    Terms & Condition
                  </a>
                </li>
                <li>
                  <a href="/privacy-policy" target="_blank">
                    Privacy & Policy
                  </a>
                </li>
              </ul>
            </nav>
            <div className="footer-marketing__col">
              <div className="footer-marketing__title">Contact Us</div>
              <ul className="footer-marketing__contact-list d-flex flex-column">
                <li className="d-flex items-center">
                  <span className="footer-marketing__contact-icon d-flex justify-center items-center">
                    <img src={phoneImage} alt="Phone" />
                  </span>
                  <a href="tel: +1 (888)787-3036">+1 (888)787-3036</a>
                </li>
                <li className="d-flex items-center">
                  <span className="footer-marketing__contact-icon d-flex justify-center items-center">
                    <img src={mailImage} alt="Email" />
                  </span>
                  <a href="mailto: support@lottoreco.com">
                    support@lottoreco.com
                  </a>
                </li>
              </ul>
              <div className="footer-marketing__social-links">
                <div className="footer-marketing__title">Follow Us</div>
                <div className="footer-marketing__social-icons d-flex">
                  <a href="https://twitter.com/lottoreco" target="_blank" rel="noopener noreferrer" className="footer-marketing__social-link" aria-label="Follow LottoReco on Twitter">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/company/lottoreco" target="_blank" rel="noopener noreferrer" className="footer-marketing__social-link" aria-label="Follow LottoReco on LinkedIn">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-marketing__bottom">
        <hr className="footer-marketing__divider" />
        <div className="footer-marketing__copyright">
          ©{new Date().getFullYear()} LottoReco. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
